module.exports = __webpack_public_path__ + "static/bwimgfm-a9551832ea96e782dc9b1a7e93223cae.jpg";